var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeItUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44448 15.9993C3.34454 15.999 3.24762 15.965 3.16935 15.9029C3.08835 15.8391 3.03206 15.749 3.01011 15.6483C2.98816 15.5475 3.00192 15.4423 3.04902 15.3505L6.14516 9.33204H0.778283C0.687626 9.33213 0.599116 9.30446 0.524647 9.25276C0.450178 9.20106 0.393319 9.1278 0.361711 9.04284C0.329848 8.9577 0.324839 8.86484 0.34736 8.77678C0.36988 8.68871 0.418848 8.60966 0.487668 8.55027L10.2687 0.106255C10.3486 0.0381331 10.45 0.000492578 10.555 2.2553e-07C10.6546 -0.000100238 10.7513 0.033366 10.8295 0.0949942C10.9106 0.158857 10.9671 0.248943 10.9892 0.349834C11.0112 0.450725 10.9976 0.556153 10.9505 0.648079L7.85437 6.66655H13.2219C13.3126 6.66646 13.4011 6.69413 13.4756 6.74583C13.55 6.79753 13.6069 6.87079 13.6385 6.95575C13.6705 7.04088 13.6755 7.13376 13.653 7.22185C13.6305 7.30994 13.5815 7.38899 13.5126 7.44832L3.7358 15.8923C3.655 15.962 3.55184 16.0002 3.44518 16",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeItUpActive);
export default __webpack_public_path__ + "static/media/chargeItUp_active.bba1fc5de5acf75050223e2d5f4178cd.svg";
export { ForwardRef as ReactComponent };